module.exports = ".upload {\r\n  margin-left: 10px;\r\n}\r\n"